import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { UtilService } from './util-service';
import { GestaoPcaService } from './gestao-pca-service';

@Injectable()
export class EspeciesProcessuaisService {

  constructor(http: HttpClient,
    private utilService: UtilService,  
    private gestaoPcaService: GestaoPcaService) {
  }

  public listarEspeciesProcessuais(): Observable<any> {
    let urlObtencaoDados: string = "EspeciesProcessuais/listarEspecies/" + this.gestaoPcaService.getPCA().id;
    return this.utilService.getJSON(urlObtencaoDados);
  }

  public salvarEspeciesProcessuais(jsonObjeto): Observable<any> {
    let urlObtencaoDados: string = "EspeciesProcessuais/salvar";
    return this.utilService.postJSON(urlObtencaoDados, jsonObjeto);
  }
}


// WEBPACK FOOTER //
// ./src/providers/especies-processuais-service.ts